function CheckMark({ checked, size = 'sm' }) {
  if (size === 'lg') {
    return (
      <span
        className={`flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-2 border-solid ${
          checked ? 'border-primary-purple-01 bg-primary-purple-01' : 'border-gray02 bg-transparent'
        }`}
      >
        {checked ? (
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden>
            <path d="M1 5L5 9L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : null}
      </span>
    );
  }

  return (
    <span className="flex h-[18px] w-[14px] shrink-0 items-center justify-center" aria-hidden>
      <svg width="12" height="10" viewBox="0 0 12 10" fill="none">
        <path
          d="M1 5L4.5 8.5L11 1.5"
          stroke={checked ? '#8B68DD' : '#D9D9D9'}
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default function AgreementRow({
  label,
  checked,
  onToggle,
  bold = false,
  showArrow = false,
  onArrowClick,
  size = 'sm',
}) {
  return (
    <div className="flex w-full items-center gap-3.5">
      <button
        type="button"
        onClick={onToggle}
        className="flex flex-1 items-center gap-3.5 border-0 bg-transparent p-0 text-left"
      >
        <CheckMark checked={checked} size={size} />
        <span
          className={`text-[#2E3548] ${bold ? "font-['Pretendard'] text-[16px] font-bold" : "font-['Pretendard'] text-[14px] font-normal"}`}
        >
          {label}
        </span>
      </button>
      {showArrow ? (
        <button
          type="button"
          onClick={onArrowClick}
          className="flex h-6 w-6 items-center justify-center border-0 bg-transparent p-0"
          aria-label="약관 상세"
        >
          <svg width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden>
            <path d="M1.5 1L6.5 6L1.5 11" stroke="#5E5E5E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      ) : null}
    </div>
  );
}
